import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { t } from 'i18next';



class IndicateursStats extends Component {

  constructor(props) {
    super(props);
    // N’appelez pas `this.setState()` ici !
    this.state = {
      data: [],
      nomIndicateur : null,
    };
    

  }



  componentDidMount() {
    this.DefaultLineChart();
  }



  DefaultLineChart = async () => {
    try {

      switch(this.props.idIndicateur) {
        case 1:
          this.setState({ nomIndicateur: t('indicateur1')});
          break;
          case 2:
            this.setState({ nomIndicateur: t('indicateur2')});
            break;
            case 3:
            this.setState({ nomIndicateur: t('indicateur3')});
            break;
            case 4:
            this.setState({ nomIndicateur: t('indicateur4')});
            break;
            case 5:
            this.setState({ nomIndicateur: t('indicateur5')});
            break;
            case 6:
            this.setState({ nomIndicateur: t('indicateur6')});
            break;
            case 7:
            this.setState({ nomIndicateur: t('indicateur7')});
            break;
            case 8:
            this.setState({ nomIndicateur: t('indicateur8')});
            break;
            case 9:
            this.setState({ nomIndicateur: t('indicateur9')});
            break;
            case 10:
            this.setState({ nomIndicateur: t('indicateur10')});
            break;
        default:
          return null;
      }
      
      this.setState({ data: this.props.data });

    
    } catch (err) {
      console.error(err.message);
    }
  }




  render() {
    
    Highcharts.setOptions({
      lang: {
        viewData: t('viewData'),
        hideData: t('hideData'),
        viewFullscreen: t('viewFullscreen'),
        exitFullscreen: t('exitFullscreen'),
        exportData: {
          categoryHeader: t('annee')
        } ,
        }
    });

    let option = {
      exporting:{
        buttons:{
          contextButton:{
            menuItems:['viewFullscreen','printChart','viewData','separator','downloadPNG','downloadJPEG','downloadPDF','downloadSVG','separator','downloadXLS','downloadCSV']
          }
        },
        menuItemDefinitions: {
         
          "printChart": {text: t('printChart')},
          "downloadPNG": {text: t('downloadPNG')},
          "downloadJPEG": {text: t('downloadJPEG')},
          "downloadPDF": {text: t('downloadPDF')},
          "downloadSVG": {text: t('downloadSVG')},
          "downloadXLS": {text: t('downloadXLS')}, 
          "downloadCSV": {text: t('downloadCSV')}
          }
      },
      accessibility: {
        enabled: false
      },
      chart: {
        type: this.props.typeChart
      },
      title: {
        text: this.state.nomIndicateur,
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        }
      },
      xAxis: {
        type: 'category',
        reversed: this.props.currentLanguageCode === 'ar' ? true : false
      },
      yAxis: {
        title: {
          text: this.props.typeIndicateur === 'percent' ? t('taux') : t('montant') ,
          style: {
            fontSize: '18px',
            fontWeight: 'bold'
          }
        },

        labels: {
          format: '{value}',
          formatter: function () {
            return Highcharts.numberFormat(this.value, 0);
          }
        },
        opposite: this.props.currentLanguageCode === 'ar' ? true : false
      },
      legend: {
        enabled: false
    },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            format: this.props.typeIndicateur === 'percent' ? '{point.y:,.2f} %' : '{point.y:,.3f} '+t('dt') ,
          },
          enableMouseTracking: true
        }
      },
      tooltip: {
        style: {
          fontSize: '18px',
          fontWeight: 'bold'
        },
        pointFormat:this.props.typeIndicateur === 'percent' ? '{series.name}: {point.y} %' : '{series.name}: {point.y} '+t('dt'),
      },
      series: [
        {
            name: this.props.typeIndicateur === 'percent' ? t('valeurStatsPercent') : t('valeurStatsMontant') ,
            colorByPoint: true,
            data:this.props.data
        }
        ]
    
    }


    return (




      <div className="col-md-12">



        <HighchartsReact highcharts={Highcharts} options={option} />




      </div>


    );
  }
}
export default IndicateursStats;
